import { c as _c } from "react/compiler-runtime";
import { Percent } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { Card, CardContent } from "@osmix/ui/card";

/**
 * Ставки комиссии переехали из «Финансов» в собственный раздел (встреча
 * 25.09.2026). Карточка оставлена на прежнем месте, чтобы привычный путь не
 * обрывался пустотой.
 */
export function CommissionsMovedNote() {
  const $ = _c(12);
  const {
    t
  } = useTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Percent className="size-4 text-muted-foreground" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("commissions.moved.text");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="flex items-center gap-2 text-sm">{t0}<span>{t1}</span></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("commissions.moved.link");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <Link to="/commissions" className="text-sm font-medium text-primary hover:underline">{t3}</Link>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <Card className="py-0"><CardContent className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 sm:px-6">{t2}{t4}</CardContent></Card>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}